import React, { useState } from 'react';
import axios from 'axios';
import { host_url } from '../../App'; // Import host_url
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';
import './FreizeitHinzufuegen.css';
import '../Freizeit.css';

function FreizeitHinzufuegen() {
  const [name, setName] = useState('');
  const [beschreibung, setBeschreibung] = useState('');
  const [kosten, setKosten] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${host_url}/freizeitangebote`, {
        Name: name,
        Beschreibung: beschreibung,
        Kosten: kosten
      });
      if (response.status === 200) {
        setName('');
        setBeschreibung('');
        setKosten('');
        setShowSuccessModal(true);
      }
    } catch (error) {
      console.error('Fehler beim Hinzufügen des Freizeitangebots:', error);
      alert('Fehler beim Hinzufügen des Freizeitangebots');
    }
  };

  return (
    <KernteamLayout>
    <div className="container">
      <BackArrow to="/freizeit" />
      <h1 className="section-title">Neues Freizeitangebot hinzufügen</h1>
      <form onSubmit={handleSubmit} className="freizeit-hinzufuegen-form">
        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Gib den Namen des Angebots ein"
            required
          />
        </div>
        <div className="form-group">
          <label>Beschreibung</label>
          <textarea
            value={beschreibung}
            onChange={(e) => setBeschreibung(e.target.value)}
            placeholder="Beschreibe das Angebot"
            required
          />
        </div>
        <div className="form-group">
          <label>Kosten in Stormark</label>
          <input
            type="number"
            value={kosten}
            onChange={(e) => setKosten(e.target.value)}
            placeholder="Kosten in Stormark"
            required
          />
        </div>
        <button type="submit">Freizeitangebot hinzufügen</button>
      </form>
      {showSuccessModal && (
        <div className="fv-success-overlay">
          <div className="fv-success-modal">
            <p>Freizeitangebot erfolgreich hinzugefügt</p>
            <div className="fv-success-buttons">
              <button onClick={() => setShowSuccessModal(false)}>Schließen</button>
              <button onClick={() => { window.open('/freizeitmarkieren', '_blank'); setShowSuccessModal(false); }}>
                Auf Karte markieren
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </KernteamLayout>
  );
}

export default FreizeitHinzufuegen;
